import GhostContentAPI from '@tryghost/content-api'
import type { Params } from '@tryghost/content-api'
import { GHOST_API, GHOST_KEY } from '@/config'

const api = new GhostContentAPI({
  url: GHOST_API,
  key: GHOST_KEY,
  version: 'v5.0',
})

const option: Params = {
  limit: 4,
  include: [ 'tags', 'authors' ],
  fields: [
    'id', 'slug', 'title', 'excerpt', 'feature_image', 'feature_image_alt',
    'primary_tag', 'primary_author', 'published_at',
  ],
}

export function getPost(slug: string) {
  return api.posts.read({ slug }, option)
}

export function getLatestPosts() {
  return api.posts.browse(option)
}

export function getPageContents(slug: string) {
  return api.pages.read({ slug })
}
